import axiosClient from '@/lib/axios';
import { Metadata } from '@/types';
import { QueryFunction, useQuery } from '@tanstack/react-query';

type VoteResponse = {
  data: {
    id: number;
    points_description: string;
    clause: string;
    can_user_vote: boolean;
  }[];
  metadata: Metadata;
};

type VoteParams = {
  urlParams: {
    page?: number;
    token?: string;
  };
  meetingID: number;
  companyID: number;
  meetingAttendeeID?: number;
};

const getVoteQuestions = async (
  urlParams: VoteParams['urlParams'],
  companyID: number,
  meetingID: number,
  meetingAttendeeID?: number,
): Promise<VoteResponse> => {
  if (urlParams.token) {
    const { data } = await axiosClient.get<VoteResponse>(
      `/companies/meetings/${meetingID}/meeting-points/user-voting/public?page=${urlParams.page}&limit=1&token=${urlParams.token}&user_id=${meetingAttendeeID}`,
    );
    return data;
  } else {
    const { data } = await axiosClient.get<VoteResponse>(
      `/companies/${companyID}/meetings/${meetingID}/meeting-points/user-voting?page=${urlParams.page}&limit=1`,
    );
    return data;
  }
};

type QueryFnType = typeof getVoteQuestions;

type UseGetVoteQuestionsOptions = {
  urlParams: VoteParams['urlParams'];
  companyID: number;
  meetingID: number;
  meetingAttendeeID?: number;
  config?: QueryFunction<QueryFnType>;
};

export const useGetVoteQuestions = ({
  urlParams,
  companyID,
  meetingAttendeeID,
  meetingID,
  config,
}: UseGetVoteQuestionsOptions) => {
  return useQuery({
    queryKey: ['vote', 'questions', urlParams],
    queryFn: () => getVoteQuestions(urlParams, companyID, meetingID, meetingAttendeeID),
    ...config,
  });
};
